import { Action } from 'redux';
import { cloneDeep } from 'lodash';
// Import models.
import {
	ProcessTarget,
} from '@app/models/app';
// Import States.
import {
	AppState,
} from '@app/redux/states';
// Import Actions.
import {
	StartProcessingAction,
	EndProcessingAction
} from '@app/redux/actions';
// Load enumerations.
import {
	OverlayTarget
} from '@app/enumerations';


/**
 * This handles initializing the state.
 * @param state
 */
let initializeState = (state: AppState, overlayTarget: OverlayTarget): AppState => {
	let newState: AppState = { ...state };
	// Initialize the process targets.
	newState.processTargets = cloneDeep<{ [id: string]: ProcessTarget }>(newState.processTargets);

	if (!newState.processTargets[overlayTarget]) {
		newState.processTargets[overlayTarget] = new ProcessTarget({
			messages: {}
		});
	}
	return newState;
}


// Start Processing Reducer.

let StartProcessingReducer = (state: AppState, action: Action): AppState => {
	let startProcessingAction: StartProcessingAction = action as StartProcessingAction;
	let overlayTarget: OverlayTarget = startProcessingAction.overlayTarget;
	let messageId: string = startProcessingAction.messageId;
	let message: string = startProcessingAction.message;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, overlayTarget);

	newState.processTargets[overlayTarget].messages[messageId] = message;

	return newState;
}


// End Processing Reducer.

let EndProcessingReducer = (state: AppState, action: Action): AppState => {
	let endProcessingAction: EndProcessingAction = action as EndProcessingAction;
	let overlayTarget: OverlayTarget = endProcessingAction.overlayTarget;
	let messageId: string = endProcessingAction.messageId;
	// Create copy of the of app state.
	let newState: AppState = initializeState(state, overlayTarget);

	delete newState.processTargets[overlayTarget].messages[messageId];

	return newState;
}


// Export reducers.
export {
	StartProcessingReducer,
	EndProcessingReducer
};